import { Model } from 'spraypaint';
import { Organisation } from '@/api';

export enum OrganisationType {
  'Regular' = 0,
  'TrainingProvider' = 1,
  'TrainingSession' = 2,
  'Trial' = 3,
}

@Model()
export default class GeccoOrganisation extends Organisation {
  static jsonapiType = 'organisations';

  static url(id?: string | number): string {
    // add Django's trailing slash
    return `${super.url(id)}refresh-gecco-org/`;
  }

  static scopeFactory() {
    return GeccoOrganisation.includes([]);
  }
}
